"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M13 5c-.55 0-1 .45-1 1v4.59l-8.29-8.3a1.003 1.003 0 00-1.42 1.42l8.3 8.29H6c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"];
//# sourceMappingURL=arrow-bottom-right.js.map